import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Inbox14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.32494 1.25C2.83095 1.25 2.3833 1.54092 2.18267 1.99233L0.357736 6.09843C0.286703 6.25826 0.25 6.43121 0.25 6.60611V11.5C0.25 12.1904 0.809645 12.75 1.5 12.75H12.5C13.1904 12.75 13.75 12.1904 13.75 11.5V6.60611C13.75 6.43121 13.7133 6.25826 13.6423 6.09843L11.8173 1.99233C11.6167 1.54092 11.1691 1.25 10.6751 1.25H3.32494ZM2.15407 5.75L3.4874 2.75H10.5126L11.8459 5.75H9.5C8.95539 5.75 8.53375 6.40559 8.18934 6.75H5.81066C5.46625 6.40559 5.04461 5.75 4.5 5.75H2.15407ZM1.75 7.25V11.25H12.25V7.25H9.81066C9.46625 7.59441 9.04461 8.25 8.5 8.25H5.5C4.95539 8.25 4.53375 7.59441 4.18934 7.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Inbox14.displayName = 'Inbox14';
export default Inbox14;
